/* Calla theme behaviours: hero slideshow, product gallery, header bag count. Plain JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Hero slideshow ---------- */
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.cl-hero-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.cl-hero-dot'));
    if (slides.length < 2) return;
    var secs = parseFloat(root.getAttribute('data-seconds') || '6');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, paused = false, hover = false, startedAt = 0, remaining = 0;
    var toggle = root.querySelector('.cl-hero-toggle');

    function show(k) {
      i = ((k % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
        /* restart the fill animation */
        var f = d.querySelector('.cl-hero-fill');
        if (f) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
      });
      root.classList.toggle('is-dark', slides[i].getAttribute('data-dark') === 'true');
    }
    function clear() { if (timer) { clearTimeout(timer); timer = null; } }
    function arm(ms) {
      clear();
      if (!(secs > 0) || reduce) return;
      startedAt = Date.now(); remaining = ms;
      timer = setTimeout(function () { timer = null; go(i + 1); }, ms);
    }
    function halt() { if (!timer) return; remaining = Math.max(0, remaining - (Date.now() - startedAt)); clear(); }
    function resume() { if (timer) return; arm(remaining > 0 ? remaining : secs * 1000); }
    function go(k) { show(k); remaining = secs * 1000; if (!paused && !hover) arm(remaining); else clear(); }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    var prev = root.querySelector('.cl-hero-prev'), next = root.querySelector('.cl-hero-next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (toggle) toggle.addEventListener('click', function () {
      paused = !paused;
      root.classList.toggle('is-paused', paused);
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      if (paused) halt(); else if (!hover) resume();
    });
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { hover = true; halt(); root.classList.add('is-paused'); });
      root.addEventListener('mouseleave', function () { hover = false; if (!paused) { root.classList.remove('is-paused'); resume(); } });
    }
    /* swipe */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });

    show(0);
    root.style.setProperty('--cl-secs', secs + 's');
    arm(secs * 1000);
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('.cl-gallery-main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.cl-thumb'));
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.querySelector('img');
        main.src = t.getAttribute('data-src') || img.src;
        if (t.getAttribute('data-srcset')) main.srcset = t.getAttribute('data-srcset');
        main.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
        t.classList.add('is-active'); t.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.cl-hero'), initHero);
    Array.prototype.forEach.call(document.querySelectorAll('.cl-gallery'), initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Theme editor re-renders sections: re-init the one that changed */
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.cl-hero'), initHero);
    Array.prototype.forEach.call(e.target.querySelectorAll('.cl-gallery'), initGallery);
  });
})();
